<template>
    <div class="pdt-30">
        <div class="d-flex justify-content-between align-items-center pdb-20">
            <h2> IATSE Staff  </h2>
        </div>
    </div>
</template>
